import React from 'react';

const SvgGroup = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M18.082 9.687H9.407V8.02h8.675zm0 1.257H9.407v1.667h8.675zm0 2.924H9.407v1.666h8.675zM7.667 8.02H5.918v1.667h1.749zm0 2.924H5.918v1.667h1.749zm0 2.924H5.918v1.666h1.749zM22 5.111v13.333a1.112 1.112 0 0 1-1.111 1.112H3.111A1.112 1.112 0 0 1 2 18.444V5.111A1.112 1.112 0 0 1 3.111 4h17.778A1.112 1.112 0 0 1 22 5.111zm-1.639.528H3.639V18h16.722z" />
  </svg>
);

export default SvgGroup;
